import { render } from "./HeaderLayout.vue?vue&type=template&id=067612c9"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/candidate-package/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "067612c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('067612c9', __exports__)) {
    api.reload('067612c9', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=067612c9", () => {
    api.rerender('067612c9', render)
  })

}


export default __exports__